<template>
  <div class="modal-overlay" ref="modalOverlay" v-show="this.isDisplayed">
    <div class="modal">

      <div class="header-container">
        <h2 v-if="title">{{title}}</h2>
        <button type="button" class="button-icon-custom" @click="closeModal()"><span class="fas fa-xmark"></span></button>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
let activeModal = null;

export default {
  name: 'CustomModal',
  props: ['callback', 'title'],
  components: {},
  data() {
    return {
      isDisplayed: false,
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
    if(activeModal === this){
      activeModal = null;
    }
  },
  methods: {
    handleKeydown(event) {
      if(event.key === 'Escape' && this.isDisplayed && activeModal === this){
        this.closeModal();
      }
    },
    openModal() {
      // prevent scroll from happening
      const body = document.body;
      if (body) body.style.overflow = "hidden";

      this.isDisplayed = true;
      activeModal = this;
    },
    closeModal() {
      // reset scroll
      const body = document.body;
      if (body) body.style.overflow = "auto";

      this.isDisplayed = false;
    }
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
.modal-overlay
  position fixed
  //overflow auto
  z-index 20
  top 0
  bottom 0
  left 0
  right 0
  display flex
  justify-content center
  align-items center
  background-color rgba(0, 0, 0, 0.50)
  backdrop-filter blur(1.5px)
  -webkit-backdrop-filter blur(1.5px)
  .modal
    background white
    height auto
    width 400px
    padding-bottom 30px
    border-radius 10px
    box-shadow: 0 0 5px rgba(0,0,0,0.30)
    .content
      padding-right 30px
      padding-left 30px

.header-container
  display flex
  justify-content space-between
  h2
    font-size 1.6em
    text-transform uppercase
    color THEME_COLOR_PRIMARY
    margin-left 15px
    margin-top 15px
    margin-bottom 10px

// Pour les téléphone
@media only screen and (max-width: TABLET_SIZE)
  .modal-overlay
    position absolute
    align-items flex-start
    .modal
      min-height 100%
      min-width 100%
    .content
      padding-right 25px
      padding-left 25px
</style>